import {
  usersTaxableLicensesStarted,
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesFailure,
} from './dashboardSlice';
import { AppThunk } from 'src/store/store';
import apiAccess from 'src/api/apiAccess';
import { PaymentPeriod } from 'src/types/tax';

type Api = typeof apiAccess;

export const getUsersActionableTaxPaymentPeriodsAsync = (): AppThunk<
  void,
  Api
> => {
  return async (dispatch, getState, api) => {
    dispatch(usersTaxableLicensesStarted());
    try {
      const response = await api.getTaxPaymentPeriods(getState());
      if (response.status === 200) {
        const actionablePeriods: PaymentPeriod[] =
          response?.data?.paymentPeriods?.filter((period: PaymentPeriod) => {
            period.licenses = period.licenses.filter(
              (license) => license.isActionable
            );
            return period.licenses.length > 0;
          });

        dispatch(usersTaxableLicensesSucceeded(actionablePeriods));
      } else {
        dispatch(
          usersTaxableLicensesFailure(
            'Something went wrong while fetching taxable license periods.'
          )
        );
      }
    } catch (error) {
      dispatch(
        usersTaxableLicensesFailure(
          'Something went wrong while fetching taxable license periods.'
        )
      );
    }
  };
};
